import currency from "currency.js";

// HELPERS
import { currenciesSymbol, separatorDecimal } from "@/helpers/formatCurrency";

// STORE
import { useRoutesStore } from "@/stores/routes";

// TYPES
import { PaymentTypeCurrency, RouteProductType } from "@/types/RouteTransferType";

interface UseCurrencyConfig {
  currency: string,
  productType?: RouteProductType,
  paymentType?: PaymentTypeCurrency
}

export function useCurrencyConfig ({ currency, productType = 'ANY', paymentType = 'ANY' }: UseCurrencyConfig) {
  const storeRoute = useRoutesStore();

  const currencyConfig = storeRoute.currenciesConfig[currency];

  const currenciesConfig =
    currencyConfig?.[productType]?.[paymentType] ||
    currencyConfig?.ANY?.[paymentType] || 
    currencyConfig?.ANY?.ANY;

  const { decimalLimit, thousandSeparator, decimalSeparator } = separatorDecimal(currency);

  return {
    decimalLimit: currenciesConfig?.decimalLimit ?? decimalLimit,
    thousandSeparator: currenciesConfig?.thousandSeparator ?? thousandSeparator,
    decimalSeparator: currenciesConfig?.decimalSeparator ?? decimalSeparator,
  };
}
